import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/apps/next/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/next/src/app/global.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/next/src/app/tailwind.css");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationDiagnostics"] */ "/vercel/path0/apps/next/src/components/common-components/HydrationDiagnostics/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/accordion/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/alert-modal/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/button/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["formatDate","FactoryOrderSection"] */ "/vercel/path0/packages/ui/components/cart/sub-parts/FactoryOrderSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/checkbox/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/custom-modal/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/details-single-tab/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/details/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/dynamic-list/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/filedrop/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/icons/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/input-field/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/link/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/loading-spinner/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/menu/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/message-bar/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/overlay-container/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/radio-button/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/search/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/single-details/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/stat-card/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/styled-wrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/tabs/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/tags/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/toggle-switch/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/tooltip/index.tsx");
